import { useMemo } from "react";
import { connect } from "react-redux";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import ComparisonCard from "./ComparisonCard";

const PayrollCharts = ({ stats, currency, periods }) => {
	const payrollTotal = useMemo(() => {
		if (!stats) return { name: "", data: [] };

		let allPayrolls = [];

		stats.forEach((entry) => {
			allPayrolls.push(parseFloat(entry?.payroll?.count.toFixed(0)));
		});

		return { name: "Total Payrolls", data: allPayrolls };
	}, [stats]);

	const payrollTotalChartOptions = {
		chart: {
			type: "column",
			backgroundColor: "transparent",
		},
		credits: false,
		title: {
			text: "Total Payrolls",
		},
		series: [payrollTotal],
		xAxis: {
			categories: periods,
		},
		yAxis: {
			min: 0,
			title: {
				text: "Payrolls",
			},
			stackLabels: {
				enabled: true,
			},
		},
		tooltip: {
			headerFormat: "<b>{point.x}</b><br/>",
			pointFormat: `{series.name}: {point.y}`,
		},
		plotOptions: {
			column: {
				pointPadding: 0.2,
				borderWidth: 0,
			},
		},
	};

	return (
		<>
			<div className="form-section col-span-3">
				<div className="form-grid col-3 col-xs-12 p-0 mt-0">
					<div className="col-span-3">
						<HighchartsReact
							highcharts={Highcharts}
							options={payrollTotalChartOptions}
						/>
					</div>
				</div>
				<div className="col-span-3">
					<div className="form-grid col-3 col-xs-12 p-0 mt-0">
						<div className="mr-5 ml-5">
							<ComparisonCard
								cardName={"Gross"}
								currentData={stats[stats.length - 1]?.payroll?.gross}
								previousData={stats[stats.length - 2]?.payroll?.gross}
								period={stats[stats.length - 1]?.period}
							/>
						</div>
					</div>
				</div>
				<div className="clearfix" />
			</div>
		</>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollCharts);
